'use es6';

import ImmutableModel from 'DesignData/models/ImmutableModel';
import PortalCopyTypes from 'DesignData/enums/PortalCopyTypes';
/**
 * Wrapper class of CustomWidget data.
 * Intended for reflection and helper methods.
 */

export default class CustomWidget extends ImmutableModel {
  /**
   * @constructor
   */
  constructor(props) {
    return super(props);
  }

  getPortalCopyType() {
    return PortalCopyTypes.CUSTOM_WIDGET;
  }

  static forEachField(fields, callback) {
    fields.forEach(callback);
  }

  forEachField(callback) {
    return CustomWidget.forEachField(this.fields, callback);
  }

}